import { cva } from '@/styled-system/css';

export const toastProviderListRecipe = cva({
  base: {
    display: 'flex',
    listStyle: 'none',
    marginInline: 'layout.tight',
    marginBlockStart: 'layout.tight',
  },
  variants: {
    placement: {
      'top-start': { alignItems: 'flex-start', flexDirection: 'column-reverse' },
      'top': { alignItems: 'center', flexDirection: 'column-reverse' },
      'top-end': { alignItems: 'flex-end', flexDirection: 'column-reverse' },
      'bottom-start': { alignItems: 'flex-start', flexDirection: 'column' },
      'bottom': { alignItems: 'center', flexDirection: 'column' },
      'bottom-end': { alignItems: 'flex-end', flexDirection: 'column' },
    },
  },
});
